import { getCatalog } from 'src/replicant/catalog/catalog.getters';
import type { CatalogItem } from 'src/replicant/catalog/catalog.ruleset';
import { decorationItems } from 'src/replicant/decoration/decoration.ruleset';
import { getRandomItemFromArray } from 'src/replicant/utils/random';
import StateObserver from 'src/StateObserver';

/**
 * Short get catalog item function
 */
export function getCatalogItems(): CatalogItem[] {
  const { user } = StateObserver.getState();

  return getCatalog(user);
}

/**
 * Generate random decoration item for debug and tests
 */
export const createCatalogDecorationItem = (
  type: 'decoration' | 'accessory',
) => ({
  type,
  id: getRandomItemFromArray([...decorationItems], Math.random).id,
  tags: getRandomItemFromArray([...decorationItems], Math.random).tags,
  slot: getRandomItemFromArray([...decorationItems], Math.random).slot,
  theme: getRandomItemFromArray([...decorationItems], Math.random).theme,
  room: getRandomItemFromArray([...decorationItems], Math.random).room,
  image: getRandomItemFromArray([...decorationItems], Math.random).image,
  tier: getRandomItemFromArray([1, 2, 3, 4], Math.random),
  maxTier: getRandomItemFromArray([1, 2, 3, 4], Math.random),
  quantity: getRandomItemFromArray([1, 2, 3, 5, 10, 20], Math.random),
  canFuse: getRandomItemFromArray([true, false], Math.random),
  name_jp: getRandomItemFromArray([...decorationItems], Math.random).name_jp,
  name_en: getRandomItemFromArray([...decorationItems], Math.random).name_en,
  sell_price: getRandomItemFromArray([1, 10, 200, 1000], Math.random),
  sell_currency: 'bPoint',
  priority: getRandomItemFromArray([1, 2, 3, 5, 10, 20], Math.random),
  currency: 'bPoint',
  price: getRandomItemFromArray([1, 10, 200, 1000], Math.random),
});
